import { render, staticRenderFns } from "./PublicationTypePicker.vue?vue&type=template&id=4ba7aaa4&"
import script from "./PublicationTypePicker.vue?vue&type=script&lang=js&"
export * from "./PublicationTypePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports